import { atom } from 'jotai';
import { Report } from '../types';

interface State {
  isOpen: boolean;
  report?: Report;
}

export const createReportSuccessDialogAtom = atom<State>({ isOpen: false, report: undefined });
